const HowToUse = ({
  use,
  setUse,
}: {
  use: boolean;
  setUse: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <div
      className={`flex items-center gap-3 text-sm font-semibold rounded-lg bg-[#2a3035] text-dark-fg cursor-pointer mb-2 p-4 text-center`}
      title="Download Resume JSON"
      onClick={() => {
        setUse(!use);
      }}
    >
      <i className="fa fa-wrench" />
      <div className="text-left">How To Use</div>
    </div>
  );
};

export default HowToUse;
